module.exports = __webpack_public_path__ + "static/media/climatizacion.ebf0ceeb.svg";